module.exports = __webpack_public_path__ + "static/media/warning.ec2734c7.svg";